import { RxStompConfig } from '@stomp/rx-stomp';

enum ServerMessagesEndpoint {
  Topic = '/topic',
  Hub = '/hub',
  Load = '/load',
  Uli = '/uli',
}

export enum TopicsEnum {
  Hub = 'HUB',
  Load = 'LOAD',
  Uli = 'ULI',
}

export const TOPICS_URLS: Record<TopicsEnum, string> = {
  [TopicsEnum.Hub]: `${ServerMessagesEndpoint.Topic}${ServerMessagesEndpoint.Hub}/:hubId`,
  [TopicsEnum.Load]: `${ServerMessagesEndpoint.Topic}${ServerMessagesEndpoint.Hub}/:hubId${ServerMessagesEndpoint.Load}/:loadNumber`,
  [TopicsEnum.Uli]: `${ServerMessagesEndpoint.Topic}${ServerMessagesEndpoint.Hub}/:hubId${ServerMessagesEndpoint.Uli}/:uliId`,
};

export const STOMP_DEFAULT_CONFIG: RxStompConfig = {
  brokerURL: '',
  connectHeaders: {},
  heartbeatIncoming: 0,
  heartbeatOutgoing: 20000,
  reconnectDelay: 5000,
};
